var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';

var EMPTY = {};

export default function access(validate, fallback, shouldUpdate) {
  return function (Component) {
    var _class, _temp2;

    return _temp2 = _class = function (_PureComponent) {
      _inherits(Access, _PureComponent);

      function Access() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Access);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Access.__proto__ || Object.getPrototypeOf(Access)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          access: undefined
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Access, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (shouldUpdate(this.props, EMPTY)) {
            this.update(this.props, EMPTY);
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (shouldUpdate(nextProps, this.props)) {
            this.update(nextProps, this.props);
          }
        }
      }, {
        key: 'update',
        value: function update(nextProps, props) {
          var access = validate(nextProps, props);
          this.setState({ access: access });
          if (!access && access !== this.state.access) {
            fallback(nextProps, props);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          if (this.state.access) {
            return React.createElement(Component, this.props);
          }

          return null;
        }
      }]);

      return Access;
    }(PureComponent), _class.displayName = 'access(' + (Component.displayName || Component.name || 'Component') + ')', _temp2;
  };
}